import { PublicFileUrl } from "../../services/config";

export const EXPERIENCE_TYPES = [
  { value: "video", label: "ویدیویی" },
  { value: "voice", label: "صوتی" },
  { value: "photo", label: "تصویری" },
  { value: "text", label: "متنی" },
];

export const TYPE_LABEL = Object.fromEntries(
  EXPERIENCE_TYPES.map((t) => [t.value, t.label])
);

export function publicFileUrl(name) {
  if (!name) return "";
  if (/^(blob:|https?:\/\/)/i.test(name)) return name;
  return `${PublicFileUrl}public/files/${name}`;
}

export function toFaDigits(value) {
  return String(value).replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
}

export function formatDuration(totalSeconds) {
  const sec = Math.max(0, Math.round(totalSeconds || 0));
  const mm = String(Math.floor(sec / 60)).padStart(2, "0");
  const ss = String(sec % 60).padStart(2, "0");
  return toFaDigits(`${mm}:${ss}`);
}

export function apiErrorMessage(error, fallback) {
  return (
    error?.response?.data?.errors?.[0]?.message ||
    error?.response?.data?.message ||
    fallback
  );
}
